import { Injectable } from '@angular/core';
import { AuthRequests } from './auth/auth.requests';
import { UserRequests } from './user/user.requests';
import { LocationsRequests } from './locations/locations.requests';
import { RolesRequests } from './roles/roles.requests';
import { ProjectsRequests } from './projects/projects.requests';
import { DailyLogssRequests } from './daily-logs/daily-logs.requests';
import { WidgetsService } from './general/widgets.service';
import { ContractDefinitionsRequests } from './contracts-definitions/contracts-definitions.requests';
import { WalkthroughServices } from './walkthrough/walkthrough.services';
import { CompaniesRequests } from './companies/companies.requests';
import { ContractsRequests } from './contracts/contracts.requests';
import { CsiDivisionsRequests } from './csiDivisions/csiDivisions.requests';
import { QuestionnaireRequests } from './questionnaire/questionannire.requests';
import { BillingRequests } from './billing/billing.requests';
import { ReadersRequests } from './readers/readers.requests';
import { RegistrationRequests } from './registration/registration.requests';

@Injectable()
export class ApiRequestsService {

  constructor(
    public auth: AuthRequests,
    public user: UserRequests,
    public companies: CompaniesRequests,
    public locations: LocationsRequests,
    public roles: RolesRequests,
    public projects: ProjectsRequests,
    public dailyLogs: DailyLogssRequests,
    public widgets: WidgetsService,
    public contractDefinitions: ContractDefinitionsRequests,
    public walkthroughServices: WalkthroughServices,
    public contracts: ContractsRequests,
    public csiDivisions: CsiDivisionsRequests,
    public questionnaire: QuestionnaireRequests,
    public billing: BillingRequests,
    public readers: ReadersRequests,
    public registration: RegistrationRequests
  ) { }

}

export function ApiDeclarations() {
  return [
    AuthRequests,
    UserRequests,
    CompaniesRequests,
    LocationsRequests,
    RolesRequests,
    ProjectsRequests,
    DailyLogssRequests,
    WidgetsService,
    ContractDefinitionsRequests,
    WalkthroughServices,
    ContractsRequests,
    CsiDivisionsRequests,
    QuestionnaireRequests,
    BillingRequests,
    ReadersRequests,
    RegistrationRequests
  ];
}
